import moment from 'moment';

moment.locale('es');
moment.defaultFormat = 'DD/MM/YYYY hh:mm A';

export default function (value: string, format: string = 'DD/MM/YYYY hh:mm A'){
    return moment(value).format(format);
}